import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandMore from "@mui/icons-material/ExpandMore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import CreateDocApi from "./document/CreateDocApi";
import ListDocApi from "./document/ListDocApi";
import DeleteDocApi from "./document/DeleteDocApi";
import GetDocApi from "./document/GetDocApi";

interface propsType {}

const DocumentApi = (props: propsType) => {
  const [open, setOpen] = useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const move = (id: string) => {
    window.location.href = `#${id}`;
  };

  return (
    <>
      <Box sx={{ p: 0, height: "100%" }}>
        <Stack direction={"column"} spacing={0} sx={{ height: "100vh", overflow: "auto" }}>
          <Box className="info-main-header-root">
            <Typography variant="h5" gutterBottom className="info-main-header-title">
              Documents APIs
            </Typography>
          </Box>
          <Divider />
          <Box className="info-main-content-root">
            <div id="top" className="width-100">
              <Box className="info-main-content-header">
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography gutterBottom className="info-main-content-title">
                    생성된 Index에 Vector data를 저장, 삭제, 변경 및 목록을 조회할 수 있습니다.
                  </Typography>
                </Box>
              </Box>
            </div>
            <div id="createIndex" className="width-100">
              <List sx={{ width: "100%", color: "green" }} component="nav" aria-labelledby="index">
                <ListItemButton onClick={handleClick} sx={{ pl: 0 }}>
                  {open ? <ExpandMore /> : <KeyboardArrowRightIcon />}
                  <ListItemText primary="목차" />
                </ListItemButton>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => {
                        move("createDoc");
                      }}
                    >
                      <ListItemText primary="도큐먼트 생성" />
                    </ListItemButton>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => {
                        move("listDoc");
                      }}
                    >
                      <ListItemText primary="도큐먼트 목록 조회" />
                    </ListItemButton>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => {
                        move("deleteDoc");
                      }}
                    >
                      <ListItemText primary="도큐먼트 삭제" />
                    </ListItemButton>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => {
                        move("getDoc");
                      }}
                    >
                      <ListItemText primary="도큐먼트 검색" />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
            </div>
            <div id="createDoc" className="width-100">
              <CreateDocApi move={move} />
            </div>
            <div id="listDoc" className="width-100">
              <ListDocApi move={move} />
            </div>
            <div id="deleteDoc" className="width-100">
              <DeleteDocApi move={move} />
            </div>
            <div id="getDoc" className="width-100">
              <GetDocApi move={move} />
            </div>
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default DocumentApi;
